import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useLicenceDeviceMutation } from '../../../apiRtk/be4feApi';
import { useGetLoadedParams } from '../../../hooks/paramsHooks';
import { ApplicationContext } from '../../../modules/commonTypes';
import { TYPE_DESCRIPTOR } from '../../../modules/notifications';
import { addSnackbarError, addSnackbarSuccess } from '../../../modules/notifications/actions';
import siteActions, { types as sitesTypes } from '../../../modules/sites';
import subscriptionActions from '../../../modules/subscription';
import messages from '../messages';

export function useGetAvailableCreditModalData(onClose: () => void, deviceId?: number, onSuccess?: () => void) {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const { companyId, siteId } = useGetLoadedParams(ApplicationContext.Site);
  const [licenceDevice, { isLoading }] = useLicenceDeviceMutation();

  async function onSubmit() {
    if (deviceId == undefined) {
      dispatch(subscriptionActions.useAvailableCreditRequest());
      onClose();
      return;
    }

    try {
      await licenceDevice({
        companyId,
        deviceId,
        siteId,
      }).unwrap();
      dispatch(addSnackbarSuccess(messages.AvailableCreditModalMessageSuccess));
      dispatch(siteActions.getCurrentSiteLicenseModel());
      dispatch({ type: sitesTypes.INVALIDATE_SITE_DASHBOARD });
      onSuccess?.();
      onClose();
    } catch {
      dispatch(addSnackbarError(messages.AvailableCreditModalMessageError, TYPE_DESCRIPTOR));
    }
  }

  return {
    formatMessage,
    isLoading,
    onSubmit,
  };
}
